import React from 'react';
import PropTypes from 'prop-types';
import confConst from '../../../../config/const';
import MapComponent from './Component';


class Map extends React.Component {

  state = {
    isReady: false,
  };

  mapReady = (d) => {
    if (!this.state.isReady)
      this.setState({isReady: true}, () => {
        this.props.mapReady(d)
      })
  };

  render() {
    let {zoom} = this.props;
    const {center, height, radius, markers, onCircleAddress, markerAddress, onZoomChange, onDragMap} = this.props;


    let isMarkerShown = false;
    if (markers && markers.length > 0) {
      isMarkerShown = true;
    }

    let isShowAddressOnMap = false;
    if(markerAddress && markerAddress.lat && markerAddress.lng){
      isShowAddressOnMap = true
    }

    if (!this.props.zoom) {
      zoom = confConst.MAP.DEFAULT_ZOOM;
      zoom += 10
    }
    return (
      <MapComponent
        isMarkerShown={isMarkerShown}
        center={center}
        zoom={zoom}
        radius={radius}
        height={height}
        mapReady={this.mapReady}
        markers={markers}
        onCircleAddress={onCircleAddress}
        isShowAddressOnMap={isShowAddressOnMap}
        markerAddress={markerAddress}
        onZoomChange={onZoomChange}
        onDragMap={onDragMap}
      />
    )
  }
}

Map.propTypes = {
  center: PropTypes.object,
  zoom: PropTypes.number,
  height: PropTypes.number,
  radius: PropTypes.number,
  mapReady: PropTypes.func,
  markers: PropTypes.array,
  onCircleAddress: PropTypes.func,
  markerAddress: PropTypes.object,
  onZoomChange: PropTypes.func,
  onDragMap: PropTypes.func,
};

Map.defaultProps = {
  height: 400
};

export default Map


// WEBPACK FOOTER //
// ./src/app/containers/Cart/components/Map/index.js